import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

const { Item } = Form;

export const InputProcess: CSSProperties = {
  height: theme["@height-button-lg"],
  fontSize: theme["@medium-font-size"],
};

export const FormItem = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-size: ${(props) => props.theme["@medium-font-size"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 300;
    padding: 3px 0;
    z-index: 1;
    > label {
      font-family: ${(props) => props.theme["@font-family"]};
      font-weight: ${(props) => props.theme["@bold-font-weight"]};
      font-size: ${(props) => props.theme["@medium-font-size"]};
      pointer-events: none !important;
      :hover {
        pointer-events: none !important;
      }
    }
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-select-arrow {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }

  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    height: ${(props) => props.theme["@height-button-lg"]};
  }

  .switch-component {
    margin-top: 10px;
  }
`;

export const LayoutForm = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-row-gap: 0px;
`;

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const ProcessesFormItem: CSSProperties = {
  width: "100%",
};

export const FormItemFieldName = styled(Item)`
  .ant-input {
    margin-left: 0;
  }

  .ant-form-item-control {
    width: 100%;
  }

  .ant-input-number {
    width: 100%;
    min-width: 60px;
  }

  &.ant-form-item {
    margin-bottom: 4px;
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 300;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-control-input-content {
    display: grid;
  }

  .ant-input {
    box-shadow: none;
    &:hover {
      border-color: ${(props) => props.theme["@secondary-color"]};
    }
  }
`;

export const CheckDescription: CSSProperties = {
  maxWidth: "100%",
  fontFamily: theme["@font-family"],
  fontWeight: 300,
  padding: "3px 0",
  zIndex: 1,
  marginRight: "5px",
  fontSize: "14px",
};

export const EventsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin-right: 70%;
  grid-column-gap: 5px;
  > div {
    display: flex;
    margin-right: 15px;
    gap: 7px;
    align-items: end;
  }
`;

export const ImageCapturesDescription = styled.div`
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: ${(props) => props.theme["@small-font-size"]};
`;
